// @flow

import React from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import locale from '../../assets/locale';
import { validatePassword } from '../../utils/validators';
import Card from '../../components/Card';
import { H2 } from '../../components/Typography';
import Input from '../../components/Input';
import Button from '../../components/Button';
import routes from '../../constants/routes';
import styles from './styles.module.scss';
import P from '../../components/Typography/P';
import CustomLink from '../../components/CustomLink/Link';
import actionTypes from '../../store/auth/actionTypes';

// type Props = {
// };

const RecoverPassword = () => {
  const dispatch = useDispatch();
  const { search } = useHistory().location;
  const isLoading = useSelector((state) => state.api.RECOVER_PASSWORD.loading);
  const token = search.split('=')[1];
  const initialFormState = {
    password: '',
    confirmPassword: '',
    isAgreed: false,
  };

  const formik = useFormik({
    initialValues: initialFormState,

    validateOnBlur: false,
    validateOnChange: false,

    onSubmit: (e) => {
      dispatch({ type: actionTypes.RECOVER_PASSWORD, payload: { password: e.password, token } });
    },

    validate: (values) => {
      const errors = {};

      if (!validatePassword(values.password)) {
        errors.password = locale.errors.account.password;
      }

      if (!values.confirmPassword) {
        errors.confirmPassword = locale.errors.account.confirmPassword;
      }

      if (values.password !== values.confirmPassword) {
        errors.password = locale.errors.password.notMatch;
        errors.confirmPassword = locale.errors.password.notMatch;
      }

      return errors;
    },
  });

  const { values, errors, dirty } = formik;

  const isButtonDisabled = !dirty;
  return (
    <form onSubmit={formik.handleSubmit}>
      <Card
        use="light"
        className={styles.containerForm}
        title={<H2 color="dark" className={styles.title}>Recover Password</H2>}
      >
        <P use="dark">Password</P>
        <Input
          value={values.password}
          name="password"
          onChange={formik.handleChange}
          type="password"
          error={errors.password}
        />
        <P use="dark">Confirm password</P>
        <Input
          value={values.confirmPassword}
          name="confirmPassword"
          onChange={formik.handleChange}
          type="password"
          error={errors.confirmPassword}
        />
        <div className={styles.buttonWrapper}>
          <Button
            type="submit"
            name="Recover Password"
            use="superBlue"
            fill
            loading={isLoading}
            disabled={isButtonDisabled}
          />
        </div>
        <div className={styles.textLink}>
          <P use="dark">Already have an account?</P>
          <CustomLink name="Log in here" use="black" to={routes.auth.signIn.root} />
        </div>
      </Card>
    </form>
  );
};

export default RecoverPassword;
